module.exports = __webpack_public_path__ + "img/my-books.a2487a6d.svg";